export default __webpack_public_path__ + "static/media/auto_elek_1019_3.3f17d877.jpg";